/**
 * Harici tokenizer paketi yok. platform.openai.com/tokenizer ile uzun metinlerde kabaca hizalamak için:
 * - Boşluk, satır sonu, noktalama: hepsi UTF-8 bayt sayımına dahildir (boşluk = 1 bayt).
 * - Ham "bayt / 4" genelde OpenAI arayüzünden düşük kalır; BPE gerçek tokenizer daha ince böler.
 * - Aşağıdaki ölçek, örnek gözleme göre (~18k vs ~15k) ayarlanmıştır; metne göre yine sapar.
 * Kesin API sayımı değildir.
 *
 * @param {string} text
 * @param {string} [_modelId] uyumluluk için (kullanılmıyor)
 * @returns {number}
 */

/** Temel bayt/4 tahminine uygulanan çarpan (OpenAI tokenizer UI’ye yaklaştırmak için) */
var OPENAI_TOKENIZER_UI_SCALE = 1.2;
function utf8ByteLength(str) {
    var n = 0;
    var i = 0;
    for (i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 0x80) {
            n += 1;
        } else if (c < 0x800) {
            n += 2;
        } else if (c >= 0xd800 && c <= 0xdbff) {
            n += 4;
            i += 1;
        } else {
            n += 3;
        }
    }
    return n;
}

export function countPromptTokensLite(text, _modelId) {
    var t = text || "";
    if (!t.length) {
        return 0;
    }
    var bytes = utf8ByteLength(t);
    // bayt/4 * 1.2 ≈ bayt/3.33 — OpenAI web tokenizer tipik uzun promptlarda daha yüksek gösterir
    return Math.max(1, Math.ceil((bytes / 4) * OPENAI_TOKENIZER_UI_SCALE));
}

/**
 * Ses ajanı LLM tool tanımları (general_tools + state içi tools) için token tahmininde kullanılacak metin.
 *
 * @param {Array} generalTools
 * @param {Array} states
 * @returns {string}
 */
export function stringifyVoiceAgentToolsForTokenEstimate(generalTools, states) {
    var parts = [];
    var i;
    if (Array.isArray(generalTools) && generalTools.length > 0) {
        try {
            parts.push(JSON.stringify(generalTools));
        } catch (err) {
            parts.push("[general_tools]");
        }
    }
    if (Array.isArray(states)) {
        for (i = 0; i < states.length; i++) {
            var st = states[i];
            if (!st) {
                continue;
            }
            var tls = st.tools;
            if (!Array.isArray(tls) || tls.length === 0) {
                continue;
            }
            var label = st.name ? String(st.name) : "state_" + String(i);
            try {
                parts.push(label + ":" + JSON.stringify(tls));
            } catch (e2) {
                parts.push(label + ":[tools]");
            }
        }
    }
    return parts.join("\n");
}

/**
 * Ses ajanı: system/general prompt + tüm fonksiyon tanımları (general_tools ve state araçları) tahmini token.
 *
 * @param {string} generalPrompt
 * @param {string} modelId
 * @param {object} llm — agent.llm (general_prompt dışında general_tools, states kullanılır)
 * @returns {number}
 */
export function countVoiceAgentPromptTokensLite(generalPrompt, modelId, llm) {
    var promptPart = generalPrompt ? String(generalPrompt) : "";
    var toolsPart = "";
    if (llm && typeof llm === "object") {
        toolsPart = stringifyVoiceAgentToolsForTokenEstimate(llm.general_tools, llm.states);
    }
    var combined = promptPart;
    if (toolsPart && toolsPart.length > 0) {
        combined = combined ? combined + "\n\n" + toolsPart : toolsPart;
    }
    return countPromptTokensLite(combined, modelId);
}

/** Liste LLM $/dk (katalogdaki defaultPrice/fastPrice, ×1.5 dahil) için prompt uzunluğu çarpanı */
export var PROMPT_LIST_PRICE_CHUNK_TOKENS = 3500;

/**
 * Token sayısı chunk’ı aşmıyorsa 1; aşıyorsa token / chunk (örn. 7000 → 2).
 * Liste fiyatı bu çarpanla çarpılır, ardından komisyon (customerLlmUsdPerMinuteFromList) uygulanır.
 *
 * @param {number} tokenCount
 * @returns {number}
 */
export function promptTokensListPriceMultiplier(tokenCount) {
    var n = Number(tokenCount);
    if (!n || isNaN(n) || n <= 0) {
        return 1;
    }
    if (n <= PROMPT_LIST_PRICE_CHUNK_TOKENS) {
        return 1;
    }
    return n / PROMPT_LIST_PRICE_CHUNK_TOKENS;
}
